<template>
    <div class="wrap-icon right-section">
        <!-- <div class="wrap-icon-section wishlist">
            <a href="#" class="link-direction">
                <i class="fa fa-heart" aria-hidden="true"></i>
                <div class="left-info">
                    <span class="index">0 item</span>
                    <span class="title">FAVORITOS</span>
                </div>
            </a>
        </div> -->
        <div v-if="logado" class="wrap-icon-section minicart">
            <a rel="nofollow" class="link-direction" :href="cartRedirect">
                <i class="fa fa-shopping-basket" aria-hidden="true"></i>
                <div class="left-info">
                    <span id="kombi-cont" class="index">{{this.count}}</span>
                    <span id="kombi-redirection" class="title">MEU CARRINHO</span>     
                    <kombi-tooltip :key="'tooltip-kombi-' + count" :productList="productList" :totalKombi="totalKombi"/>                                  
                </div>                
            </a>            
        </div>
        <div v-if="kombiList.length > 1" class="wrap-icon-section minicart">
            <a rel="nofollow" class="link-direction" href="#">                
                <i class="fa fa-shopping-basket-double" aria-hidden="true"></i>
                <div class="left-info">
                    <span id="kombi-cont" class="index">{{this.countKombiList}}</span>
                    <span id="kombi-redirection" class="title">PEDIDOS/DATA</span>     
                    <kombi-list-tooltip :kombiList="kombiList"/>                                  
                </div>                
            </a>            
        </div>
        <div class="wrap-icon-section show-up-after-1024">
            <a rel="nofollow" href="#" class="mobile-navigation">
                <span></span>
                <span></span>
                <span></span>
            </a>
        </div>
    </div>
</template>

<script>
    import KombiTooltip from './KombiTooltip.vue'
    import KombiListTooltip from './KombiListTooltip.vue'
    import axios from 'axios';

    export default {
        name: 'AccountDetails',
        components: {
            KombiTooltip,
            KombiListTooltip
        },
        props: [
            'count',
            'productList',
            'totalKombi',
            'cartRedirect',
            'kombiList'
        ],
        data() {
            return {
                tipoCarrinho: "",
                totalItensCarrinho: "",
                session: {},
                kombiCodeInt: 0,
                isQuotation: false,
                logado: false
                //isVendaDireta: false,
                //isConsumoProprio: false
            }
        },
        mounted() {
            const self = this;
            setTimeout(function () {
                let session = JSON.parse(localStorage.getItem('usuarioLogado'));
                if (session && session.DadosCliente != null) {
                    self.logado = true;
                }
            }, 500);
            
        },
        computed: {
            countKombiList: function () {
                return `${this.kombiList.length} CARRINHOS`;
            }
        }
        
    }
</script>
